<template>

    <div class="shadow overflow-hidden">

      <div>

        <dl>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('violationConsequencies.punishmentMaster') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ violationConsequencies.punishment_description }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('violationConsequencies.violation') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ violationConsequencies.violation_description }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('violationConsequencies.expiredIn') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ violationConsequencies.expired_in }} Week
            </dd>
          </div>

          <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('violationConsequencies.created_by') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ violationConsequencies.created_by }}
            </dd>
          </div>

          <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('violationConsequencies.updated_by') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ violationConsequencies.updated_by }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('violationConsequencies.created_at') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ violationConsequencies.created_at }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('violationConsequencies.updated_at') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ violationConsequencies.updated_at }}
            </dd>
          </div>

        </dl>
      </div>

    </div>

    </template>
    <script>
    // /* eslint-disable */
    import { ref, reactive, watchEffect } from 'vue'
    export default {
      name: 'ViolationConsequenciesDetail',
      components: {

      },
      props: {
        propClass: {
          type: Object,
          default: () => ({ empty: true })
        }
      },
      data: function () {
        return {
        }
      },
      emits: ['close-modal', 'submit'],
      setup (props, { emit }) {
        const titleStack = ref(['Admin', 'Forms'])
        // const activeTab = ref(0)

        const violationConsequencies = reactive({
            id: '',
            punishment_master_id: '',
            sequence_no: '',
            violation_id: '',
            created_by: '',
            created_at: ''
        })

        watchEffect(() => {
          const newviolationConsequencies = props.propClass
          Object.assign(violationConsequencies, newviolationConsequencies)
        })

        return {
          titleStack,
          violationConsequencies
        }
      }
    }
    </script>
